export const ROOT = `/admin/consumer-engagement`;
